import { createStore } from 'redux';
import thunk from 'redux-thunk';
import ReduxQuerySync from 'redux-query-sync';

import { applyMiddleware } from 'helpers/redux_dev_tools';
import queryParams from './query_params';
import rootReducer from './root_reducer';

export default function (state) {
  const store = createStore(rootReducer, state, applyMiddleware(thunk));

  ReduxQuerySync({
    store: store,
    initialTruth: 'location',
    replaceState: true,
    params: queryParams
  });

  if (module.hot) {
    module.hot.accept('./root_reducer', () => {
      store.replaceReducer(require('./root_reducer'));
    });
  }

  return store;
}
